import { msg } from 'gt-react';
import { TrashIcon } from '@phosphor-icons/react';
import { Action, Subject } from '@erp/authz';
import { ProductModule } from '@erp/shared-types';
import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { z } from 'zod';
import {
  Route as pathlessAuthenticatedRoute,
  requireModules,
  requirePermission,
} from '../../route';

const NoClaimTransactionsPage = lazyRouteComponent(
  () => import('./NoClaimTransactionsPage'),
  'NoClaimTransactionsPage',
);

export const Route = createRoute({
  getParentRoute: () => pathlessAuthenticatedRoute,
  path: '/ship-and-debit/no-claim-transactions',
  validateSearch: z.object({
    filters: z.record(z.string(), z.array(z.string())).optional(),
    search: z.string().optional(),
    transactionId: z.string().optional(),
    view: z.enum(['as400', 'v2']).optional(),
    page: z.number().int().min(1).optional(),
  }),
  staticData: {
    app: {
      nav: {
        label: msg('No Claim Transactions', {
          context: 'sidebar nav label, Ship and Debit section',
        }),
        icon: <TrashIcon className="h-4 w-4" weight="fill" />,
        group: 'Ship and Debit',
        order: 56,
      },
      access: {
        modulesAnyOf: [ProductModule.SHIP_AND_DEBIT],
        permissionsAnyOf: [
          { action: Action.Read, subject: Subject.SDTransaction },
        ],
      },
    },
  },
  component: NoClaimTransactionsPage,
  loader: () => ({
    crumb: msg('No Claim Transactions', { context: 'page breadcrumb' }),
  }),
  beforeLoad: async ({ context }) => {
    requireModules({
      context,
      oneOf: [ProductModule.SHIP_AND_DEBIT],
    });
    await requirePermission({
      context,
      action: Action.Read,
      subject: Subject.SDTransaction,
    });
  },
});
